import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col, Table, Alert } from 'reactstrap';
import moment from 'moment';
import Icon from 'react-icons-kit';
import { phone } from 'react-icons-kit/fa/phone';
import { clockO } from 'react-icons-kit/fa/clockO';
import { refresh } from 'react-icons-kit/fa/refresh';
import { mapMarker } from 'react-icons-kit/fa/mapMarker';
// import { ic_local_gas_station as iconGas } from 'react-icons-kit/md/ic_local_gas_station';
// import Link from '../Link';
import { FormattedMessage } from 'react-intl';
import concat from 'lodash/concat';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

import s from './OfferEndpage.css';
import Gallery from './Gallery';
import LoadingBar from '../LoadingBar';
import PhonesList from './PhonesList';
import TechData from './TechData';
import NoPhoto from '../ThumborImage/NoPhoto';
import Price from '../Helpers/Price';
import Statuses from '../Helpers/Statuses';
import Panel from '../Helpers/Panel';
import WithDiscountLabel from '../Helpers/WithDiscountLabel';
import SuperProposalLabel from '../Helpers/SuperProposalLabel';
import TopProposalLabel from '../Helpers/TopProposalLabel';
import { parseServices } from '../Services/helpers';
import AdSenseBanner from '../../containers/AdSenseBanner';
import VerifiedLabel from '../VerifiedLabel/VerifiedLabel';
// import wrappedGift from './wrapped-gift_1f381.png';
// import eyes from './eyes_1f440.png';
// import { WrappedGift } from '../Emoji';

class OfferEndpage extends Component {
  static propTypes = {
    offer: PropTypes.shape().isRequired,
    id: PropTypes.string.isRequired,
  };

  static contextTypes = { fetch: PropTypes.func.isRequired };

  renderGallery() {
    const { offer } = this.props;
    let images = (offer.images || []).map(image => ({
      ...image,
      type: 'owner',
    }));
    if (offer.modification) {
      images = concat(
        images,
        (offer.modification.generation.images || []).map(image => ({
          ...image,
          type: 'catalog',
        })),
      );
    }
    images = images.map((image, index) => ({
      ...image,
      alt: `${offer.title} (фото ${index + 1})`,
    }));

    if (images.length > 0) {
      return <Gallery images={images} />;
    }
    return <NoPhoto className={s.no_photo} />;
  }

  render() {
    const { offer, id } = this.props;
    if (isEmpty(offer) || offer.id !== id) {
      return <LoadingBar />;
    }
    const { modification, active: isActive } = offer;
    const top = Boolean(find(offer.services, { slug: 'day_best' }));
    // const isEasterEgg = offer.id === '9590';
    const {
      labelSuperProposal,
      labelTopProposal,
      labelBestPrice: bestPrice,
      labelSuperPrice: superPrice,
      labelWithDiscount: withDiscount,
    } = parseServices(offer.services);

    return (
      <Row>
        <Col xs="12">
          {!isActive && (
            <Row>
              <Col xs="12">
                <Alert color="warning">
                  <FormattedMessage
                    id="endpage.alert.notactive"
                    defaultMessage="Оголошення не активне"
                    description=""
                  />
                </Alert>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs="8">
              <h1 className={`h3 ${s.title}`}>
                <small className="text-muted">
                  <FormattedMessage
                    id="endpage.title.part1"
                    defaultMessage="Продаж"
                    description=""
                  />
                </small>
                {` `}
                {offer.title}
                {` `}
                <small className="text-muted">{offer.location.title}</small>
                {offer.is_verified_by_payment && (
                  <VerifiedLabel id={offer.id} />
                )}
              </h1>
              {modification && <p>{modification.title}</p>}
            </Col>
            <Col xs="4" className="text-right">
              <Price
                className={s.price}
                price={offer.price}
                currency={offer.price_currency}
                best={bestPrice}
                isSuper={superPrice}
                priceUah={offer.price_uah}
                priceUsd={offer.price_usd}
              />
              {withDiscount && !(top || bestPrice) ? (
                <WithDiscountLabel />
              ) : null}
              {labelSuperProposal && <SuperProposalLabel />}
              {labelTopProposal && <TopProposalLabel />}
            </Col>
          </Row>
          <Row>
            <Col md="8" xs="12" className="mb-3">
              <Panel className={s.gallery}>{this.renderGallery()}</Panel>
            </Col>
            <Col md="4" xs="12" className="mb-3">
              <Panel>
                <div className={`lead ${s.location}`}>
                  <Icon icon={mapMarker} /> {offer.location.title}{' '}
                </div>
                {offer.is_verified_by_payment && (
                  <div className="mt-3">
                    <VerifiedLabel
                      id={offer.id}
                      tooltip={false}
                      text={
                        <FormattedMessage
                          id="endpage.verified.label.text"
                          defaultMessage="підтверджений банківською картою"
                          description=""
                        />
                      }
                    />
                  </div>
                )}
                {isActive && offer.phones ? (
                  <div className={s.phones}>
                    <div className="mb-2">
                      <PhonesList phones={offer.phones} offerId={offer.id} />
                    </div>
                    <div className={s.call_wrapp}>
                      <a
                        href={`tel:${offer.phones[0].number}`}
                        className={`btn btn-outline-success btn-sm ${s.call_button}`}
                      >
                        <Icon icon={phone} size={16} />{' '}
                        <FormattedMessage
                          id="endpage.call.button.label"
                          defaultMessage="Подзвонити"
                          description=""
                        />
                      </a>
                    </div>
                  </div>
                ) : (
                  <Alert color="info" fade={false}>
                    <FormattedMessage
                      id="endpage.alert.notactive"
                      defaultMessage="Оголошення не активне"
                      description=""
                    />
                  </Alert>
                )}
                <Table>
                  <tbody>
                    {offer.year && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.year.label"
                            defaultMessage="Рік випуску"
                            description=""
                          />
                        </td>
                        <td>{offer.year}</td>
                      </tr>
                    )}
                    {(Boolean(offer.mileage) || offer.mileage === 0) && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.mileage.label"
                            defaultMessage="Пробіг"
                            description=""
                          />
                        </td>
                        <td>
                          {offer.mileage === 0 ? (
                            <FormattedMessage
                              id="endpage.mileage.zero"
                              defaultMessage="без пробігу"
                              description=""
                            />
                          ) : (
                            <span>
                              {offer.mileage}{' '}
                              <FormattedMessage
                                id="endpage.mileage.units"
                                defaultMessage="тис. км."
                                description=""
                              />
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                    {offer.fuel && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.engine.label"
                            defaultMessage="Двигун"
                            description=""
                          />
                        </td>
                        <td>
                          {offer.fuel.title}
                          {offer.engine_capacity
                            ? `, ${offer.engine_capacity} л.`
                            : null}
                        </td>
                      </tr>
                    )}
                    {offer.drive && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.drive.label"
                            defaultMessage="Привід"
                            description=""
                          />
                        </td>
                        <td>{offer.drive.title}</td>
                      </tr>
                    )}
                    {offer.body && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.body.label"
                            defaultMessage="Кузов"
                            description=""
                          />
                        </td>
                        <td>{offer.body.title}</td>
                      </tr>
                    )}
                    {offer.gears_type && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.gears.label"
                            defaultMessage="КПП"
                            description=""
                          />
                        </td>
                        <td>{offer.gears_type.title}</td>
                      </tr>
                    )}
                    {offer.color && (
                      <tr>
                        <td>
                          <FormattedMessage
                            id="endpage.color.label"
                            defaultMessage="Колір"
                            description=""
                          />
                        </td>
                        <td>{offer.color.title}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <Statuses car={offer} />
                <ul className={s.date_statuses}>
                  <li>
                    <Icon icon={clockO} />{' '}
                    <FormattedMessage
                      id="endpage.created.label"
                      defaultMessage="створено"
                      description=""
                    />
                    : {moment(offer.created).format('DD.MM.YYYY')}
                  </li>
                  <li>
                    <Icon icon={refresh} />{' '}
                    <FormattedMessage
                      id="endpage.updated.label"
                      defaultMessage="оновлено"
                      description=""
                    />
                    : {moment(offer.updated).format('DD.MM.YYYY')}
                  </li>
                </ul>
              </Panel>
            </Col>
          </Row>
          {offer.description && (
            <Row className="mb-3">
              <Col md="12">
                <Panel>
                  <p className="h4">
                    <FormattedMessage
                      id="endpage.description.label"
                      defaultMessage="Додаткова інформація"
                      description=""
                    />
                  </p>
                  <p>{offer.description}</p>
                </Panel>
              </Col>
            </Row>
          )}
          {modification && (
            <Row>
              <Col md="12">
                <TechData techdata={modification.techdata} />
              </Col>
            </Row>
          )}
          <Row>
            <Col className="mb-3">
              <AdSenseBanner
                slot="1460006274"
                format="fluid"
                layout="in-article"
                style={{ display: 'block', textAlign: 'center' }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default withStyles(s)(OfferEndpage);
